import { useEffect, useState } from 'react';
import api from 'services/api';
import { connect } from 'react-redux';
import { isUserAuth } from 'store/ducks/auth';

const Interceptor = ({ _isUserAuth, triiderUser, haveAccount }) => {
  const [authInterceptor, setAuthInterceptor] = useState(undefined);

  const addAuthInterceptor = () => {
    const interceptor = api.interceptors.request.use(
      (config) => {
        if (_isUserAuth()) {
          config.headers = {
            ...config.headers,
            'api-token': triiderUser.token,
            source: 'partners',
          };
        }
        return config;
      },
      error => Promise.reject(error),
    );
    setAuthInterceptor(interceptor);
  };

  const removeAuthInterceptor = () => {
    api.interceptors.request.eject(authInterceptor);
    setAuthInterceptor(undefined);
  };

  useEffect(() => {
    addAuthInterceptor();
    // addErrorInterceptor();
    return () => {
      removeAuthInterceptor();
      // removeErrorInterceptor();
    };
  }, [triiderUser, haveAccount]);

  return null;
};
const mapStateToProps = state => ({
  _isUserAuth: () => isUserAuth(state.auth.triiderUser),
  triiderUser: state.auth.triiderUser,
  haveAccount: state.auth.haveAccount,
});

export default connect(mapStateToProps)(Interceptor);
